/**
 * The page is imported from **its own module**, not from the `@pages` barrel — the barrel pulls
 * every screen into one shared chunk and defeats the route-level code splitting (EPIC-003).
 */
import { createFileRoute } from '@tanstack/react-router';

import { ProfilePage } from '@pages/profile';

/**
 * `/profile` — wiring only (`rules/frontend-fsd.mdc` rule 10).
 *
 * **No permission guard, and none is possible.** Everything behind this screen is about the caller
 * themselves: the four second-factor operations are declared `selfService: true` in the route
 * registry — nobody could be denied the right to protect their own sign-in — and the personnel
 * record is self-service for the same kind of reason, with the server deciding per field how much
 * of it comes back and what may be written (`docs/api/openapi.yaml`, `GET`/`PATCH
 * /employees/{userId}`). The session guard on `_authenticated` is the whole gate.
 *
 * **No path parameter, and that is the design rather than an omission.** Who this screen is about
 * is decided by the session, so there is no value anybody could put in the address to be shown
 * somebody else — which is precisely what separates it from `/admin/members/$userId`, the screen
 * an administrator opens about anybody.
 *
 * **No loader**, so the route inherits the router's pending and error boundaries rather than
 * declaring its own. Prefetching would put the reads on the navigation's critical path to buy a
 * skeleton `DataState` already renders.
 */
export const Route = createFileRoute('/_authenticated/profile')({
  component: ProfilePage,
  staticData: { crumbKey: 'profile.title' },
});
